module.exports = __webpack_public_path__ + "img/dinapoliHeaderM.cc06aacf.png";